import React from 'react'
import { SEO } from '../../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import { userGroups } from '../../../../utils/pages-meta.json'
import UserGroupEditContent from '../../../../components/Dashboard/Subscription/UserGroupEditContent'
import { UserGroupProvider } from '../../../../UserGroupContext'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { FormLoader } from '../../../../components/Loader/FormLoader'
import Layout from '../../../../components/Dashboard/Layout/Layout'
import { Redirect, useParams } from 'react-router-dom'
import { NamedRoutes } from '../../../../routes'

const SingleUserGroupEdit = () => {
  let { id } = useParams()
  const intl = useIntl()

  return (
    <>
      {!!id && !!parseInt(id) ? <>
        <SEO title={intl.formatMessage({ id: 'UserGroups.List.EditUserGroup.Title' })}
          pathname={window.location.origin}
          titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
          image={userGroups.image}
          description={intl.formatMessage({ id: 'UserGroups.List.EditUserGroup.Title' })}
        />
        <AuthenticatedUserConsumer>
          {({ userDataLoading, userData, handleNotificationCall }) => (
            <>
              {!!userDataLoading && <FormLoader loading={true} />}
              {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={
                    <UserGroupProvider isEdit userGroupId={id}
                      handleNotificationCall={handleNotificationCall}>
                      <UserGroupEditContent pageTitle={<FormattedMessage id='UserGroups.List.EditUserGroup.Title' />} />
                    </UserGroupProvider>
                  } /> : (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                  }
                </>
              }
            </>
          )}
        </AuthenticatedUserConsumer>
      </> :
        <Redirect to={NamedRoutes.subscription.userGroups.list} />
      }
    </>
  )
}

export default SingleUserGroupEdit